define('bindingHandlers/paste',[
    'jquery',
    'lib/knockout'
], function ($, ko) {
    'use strict';

    var TEXT_PLAIN = 'text/plain';
    var TEXT = 'Text';

    ko.bindingHandlers.paste = {
        init: function (element, valueAccessor) {
            var $element = $(element),
                callback = valueAccessor();

            /**
             * Intercepts a clipboard paste event, capturing the input and invoking a callback without relying on
             * any browser specific API's.
            **/
            $element.on('paste.paste-binding', function (event) {
                var pastedText = "";
                if (event && event.originalEvent && event.originalEvent.clipboardData) {
                    pastedText = event.originalEvent.clipboardData.getData(TEXT_PLAIN);
                } else if (window.clipboardData) { // IE
                    pastedText = window.clipboardData.getData(TEXT);
                }

                callback(pastedText);
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $element.off('.paste-binding');
            });
        }
    };
});

